import DataFormulaNode from "./DataFormulaNode.js";

/**
 * TODO: write documentation
 */
export default class ChangeDataFormulaNode extends DataFormulaNode {
	static getType() {
		return "ChangeDataNode";
	}
}
